import React, { createContext, useState, useContext } from 'react';

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
    const [products, setProducts] = useState([]);

    const addProduct = (product) => {
        setProducts(prev => [product, ...prev]);
    };

    const updateProduct = (updatedProduct) => {
        setProducts(prev =>
            prev.map(p => p.id === updatedProduct.id ? updatedProduct : p)
        );
    };

    return (
        <ProductContext.Provider value={{ products, addProduct, updateProduct }}>
            {children}
        </ProductContext.Provider>
    );
};

export const useProducts = () => useContext(ProductContext);
